export const blobToBase64 = (blob: Blob): Promise<null | string> => {
  const reader = new FileReader();
  reader.readAsDataURL(blob);

  return new Promise((resolve) => {
    reader.onloadend = () => {
      if (!reader.result) {
        resolve(null);
        return;
      }
      resolve(reader.result as string);
    };
  });
};

export function renameFileExtension(file: string, extension: `.${string}`) {
  return file.replace(/\.[^/.]+$/, extension);
}

export function getFileExtensionFromType(fileType: string): `.${string}` {
  return `.${fileType.split('/')[1]}`;
}
